<template>
  <v-container class="bottom">
    <v-layout row>
      <v-flex class="containerBanner" md10 lg10 xs12 sm11 xl10>
        <img :src="img1" style="width:100%;" />
      </v-flex>
    </v-layout>
    <v-layout row>
      <div>
        <v-snackbar
          class="new-alert"
          v-model="alert"
          :timeout="timeout"
          :color="alertType"
          top="top"
        >
          {{this.alertMessage}}
          <v-icon color="white" flat @click="alert = false">close</v-icon>
        </v-snackbar>
      </div>
      <v-flex offset-xs0 offset-md1 offset-lg0 offset-sm0 offset-xl0 md9 lg10 xs12 sm11 xl10>
        <v-flex class="containerStyle2" md12 lg12 xs12 sm12>
          <v-layout>
            <v-flex md12 lg12 xs12 sm12>
              <h3 style="text-align: left">Tendencias mundiales</h3>
              <v-layout>
                <select class="form-control" id="5" v-model="op">
                  <option value="1">Desarrollo tecnológico-digital</option>
                  <option value="2">Aumento del envejecimiento y concentración demográfica</option>
                  <option value="3">Reordenamiento geopolítico</option>
                  <option value="4">Calentamiento global</option>
                  <option value="5">Mayor demanda energética</option>
                  <option value="6">Continuidad crecimiento económico</option>
                  <option value="7">Urbanización</option>
                  <option value="8">Conectividad</option>
                </select>
              </v-layout>
              <br />
              <v-layout class="lower-card">
                <v-flex md12 lg12 xs12 sm12 xl12>
                  <v-layout>
                    <v-flex md12 lg12 xs12 sm12>
                      <h2
                        class="titlep"
                        style="text-align:center; margin-top:0;"
                      >{{informacion.nombre}}</h2>
                      <br />
                      <p class="text-actividad">{{informacion.contexto}}</p>
                    </v-flex>
                  </v-layout>
                  <br />
                  <v-layout align-center justify-center>
                    <v-flex md10 lg10 xs10 sm10>
                      <p class="titulo-pregunta">Docencia</p>
                      <label
                        class="text-mision-propuesta"
                        for="comment"
                      >¿Qué haremos o qué debe hacer la unidad académica frente a esta tendencia global desde el punto de vista de la docencia de pregrado?</label>
                      <textarea
                        :disabled="!$session.getAll().permiso"
                        v-model="tipoTendencia.Docencia1"
                        style="resize:none"
                        class="form-control"
                        rows="2"
                        id="comment"
                      ></textarea>
                    </v-flex>
                  </v-layout>
                  <br />
                  <v-layout align-center justify-center>
                    <v-flex md10 lg10 xs10 sm10>
                      <label
                        class="text-mision-propuesta"
                        for="comment"
                      >¿Qué haremos o qué debe hacer la unidad académica frente a esta tendencia global desde el punto de vista de la docencia de postgrado?</label>
                      <textarea
                        :disabled="!$session.getAll().permiso"
                        v-model="tipoTendencia.Docencia2"
                        style="resize:none"
                        class="form-control"
                        rows="2"
                        id="comment"
                      ></textarea>
                    </v-flex>
                  </v-layout>
                  <br />
                  <v-layout align-center justify-center>
                    <v-flex md10 lg10 xs10 sm10>
                      <p class="titulo-pregunta">Investigación</p>
                      <v-layout align-center justify-center>
                        <v-icon size="115" v-if="empty">notification_important</v-icon>
                      </v-layout>
                      <v-layout align-center justify-center>
                        <p
                          class="text-p"
                          v-if="empty "
                        >¿Hay nuevas líneas de investigación que como académico/a debería desarrollar? ¿Cuál o cuáles?</p>
                      </v-layout>
                      <table v-if="!empty" cellpadding="0" cellspacing="0">
                        <thead class="header">
                          <tr>
                            <th
                              style="text-align: left"
                              :class="header.size"
                              v-for="(header,index) in headers"
                              :key="index"
                            >{{header.text}}</th>
                          </tr>
                        </thead>
                      </table>
                      <div v-if="!empty" class="tbl-content">
                        <table class="table-bordered" cellpadding="0" cellspacing="0" border="1">
                          <tbody>
                            <tr v-for="(item,index) in lineas" :key="index">
                              <td
                                style="text-align:left"
                                :class="headers[0].size"
                              >{{item.nombreLinea}}</td>
                              <td
                                style="text-align:left"
                                :class="headers[1].size"
                              >{{item.respuestaInvestigacion}}</td>
                              <td :class="headers[2].size">
                                <v-icon
                                  :disabled="!$session.getAll().permiso"
                                  small
                                  class="mr-2"
                                  @click="openEditLineas(item,index,'edit')"
                                >edit</v-icon>
                                <v-icon
                                  :disabled="!$session.getAll().permiso"
                                  small
                                  class="mr-2"
                                  @click="openDeleteLineas(item,index)"
                                >delete</v-icon>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <v-layout align-center justify-center>
                        <v-btn
                          v-if="this.$session.getAll().permiso"
                          color="#EB7704"
                          @click="opencreateFocos"
                        >Agregar línea</v-btn>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                  <br />
                  <v-layout align-center justify-center>
                    <v-flex md10 lg10 xs10 sm10>
                      <p class="titulo-pregunta">Vinculación con el medio</p>
                      <label
                        class="text-mision-propuesta"
                        for="comment"
                      >¿Hay nuevas relaciones con el medio externo que como académico/a o que la unidad académica debiera desarrollar? ¿Con qué actores en específico?</label>
                      <textarea
                        :disabled="!$session.getAll().permiso"
                        v-model="tipoTendencia.Vinculacion"
                        style="resize:none"
                        class="form-control"
                        rows="2"
                        id="comment"
                      ></textarea>
                    </v-flex>
                  </v-layout>
                  <v-layout align-center justify-center>
                    <v-btn
                      v-if="this.$session.getAll().permiso"
                      color="#EB7704"
                      @click="updateTendencia()"
                    >Guardar Cambios</v-btn>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-dialog v-model="edit" width="700px" persistent>
        <template v-slot:activator="{ on }"></template>
        <v-card class="new-card">
          <v-card-title>
            <span class="headline" v-if="!create">Edita tu Linea de trabajo</span>
            <span class="headline" v-if="create">Crea una Linea de trabajo</span>
          </v-card-title>
          <v-flex offset-md1 offset-lg1 offset-xs1 offset-sm1 md10 lg10 xs10 sm10>
            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label for="sel1">Indique el nombre de la línea de Trabajo</label>
                <input v-model="linea.nombreLinea" type="text" class="form-control" id="usr" />
              </v-flex>
            </v-layout>
            <br />
            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label for="sel1">¿Cómo la debería desarrollar?¿Qué se requiere?</label>
                <textarea
                  v-model="linea.respuestaInvestigacion"
                  type="text"
                  class="form-control"
                  rows="2"
                  id="usr"
                ></textarea>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#ec6a12" flat="flat" @click="edit = false">Cerrar</v-btn>
            <v-btn color="#394049" flat="flat" v-if="!create" @click="editLinea()">Guardar</v-btn>
            <v-btn color="#394049" flat="flat" v-if="create" @click="createLinea()">Crear</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="eliminar" width="500">
        <template v-slot:activator="{ on }"></template>
        <v-card class="new-card">
          <v-card-title>
            <span
              class="headline"
            >¿Está seguro de querer eliminar la línea de trabajo {{linea.nombreLinea}}?</span>
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#ec6a12" flat="flat" @click="eliminar = false">No, cancelar</v-btn>
            <v-btn color="#394049" flat="flat" @click="deleteLinea(linea)">Sí, eliminar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>


<script>
import img1 from "../../assets/BANNER_2.png";
import img3 from "../../assets/nuevaasistenciadca.png";
import nube from "../../assets/nube.png";

export default {
  data() {
    return {
      op: "1",
      lineas: [],
      linea: {},
      eliminar: false,
      empty: true,
      create: false,
      edit: false,
      nombreTendenciaAlert: "",
      tipoTendencia: "",
      img1: img1,
      img3: img3,
      ccValor: "",
      tendencia: "",
      nombreTendencia: "",
      informacion: {
        nombre: "Desarrollo digital tecnológico",
        contexto:
          "Consecuencias: Aumento del número de automóviles y barcos, y la consecuente contaminación ambiental (aunque una parte importante serán eléctricos); mayor conectividad generará una mayor pluralidad; sustitución de fuentes laborales especializadas (ej. El número de pilotos de vuelos comerciales se triplicará al 2030); el transporte y la logística de las ciudades mejorará con mayor conectividad; aumento de influencia de internet en las noticias, a través de fake news, lo que generará polarización de las elecciones; la conectividad también puede significar vulnerabilidad: el ciberespacio será uno de los campos de batalla donde los estados y actores no estatales se enfrentan; la mayoría de los sistemas de inteligencia artificial requerirán de acceso a big data"
      },
      headers: [
        {
          text:
            "¿Hay nuevas líneas de investigación que debería desarrollar?¿Cuál o cuáles? (una por fila)",
          value: "name",
          size: "col-md-5 col-lg-5 col-sm-5 col-xs-5 col-xl-5"
        },
        {
          text: "¿Cómo las debería desarrollar?¿Qué se requiere?",
          value: "desacuerdo",
          size: "col-md-5 col-lg-5 col-sm-5 col-xs-5 col-xl-5"
        },
        {
          text: "Acción",
          value: "desacuerdo",
          size: "col-md-2 col-lg-2 col-sm-2 col-xs-2 col-xl-2"
        }
      ],
      show: false,
      timeout: 4000,
      alertType: "success",
      alertMessage: "",
      alert: false,
      auth: {
        headers: { Authorization: "" + this.$session.get("jwt") }
      }
    };
  },
  created() {
    this.email = this.$session.getAll().email;
    this.ccValor = this.$session.getAll().ccData.ccValor;
    this.tipoTendencia = {
      Docencia1: "",
      Docencia2: "",
      Vinculacion: ""
    };
    this.getTendencia();
    this.getLineas();
  },

  watch: {
    // cuando 'question' cambie, se ejecutará esta función
    op: function() {
      //console.log("whatcher a detectado un cambio en user");
      //console.log(this.$route.params.id);
      this.tipoTendencia = {
        Docencia1: "",
        Docencia2: "",
        Vinculacion: ""
      };
      this.getTendencia();
      this.getLineas();
    }
  },

  methods: {
    updateTendencia() {
      //console.log("ANtes del save");
      //console.log(this.tendencia);
      this.tendencia[this.nombreTendencia] = this.tipoTendencia;
      axios
        .patch(
          process.env.ROOT_API + "/tendencia/updateTendencia",
          this.tendencia,
          this.auth
        )
        .then(response => {
          this.tendencia = response.data;
          this.show = true;
          this.showAlert(
            "success",
            "Ha actualizado " + this.nombreTendenciaAlert
          );
          //console.log(response.data);
        })
        .catch(error => {
          console.error(error);
        })
        .then(response => {
          //console.log("ME VOY AL VERFICA");
          this.verificatendencia();
        });
    },
    getTendencia() {
      axios
        .get(
          process.env.ROOT_API +
            "/tendencia/tendenciaCC?ccValor=" +
            this.ccValor,
          this.auth
        )
        .then(response => {
          this.tendencia = response.data;
          this.show = true;
          //console.log("GEEEET");
          //console.log(response.data);
        })
        .catch(error => {
          console.error(error);
        })
        .then(response => {
          this.verificatendencia();
        });
    },
    verificatendencia() {
      //console.log("ENTRE AL VERFICA");

      this.tipoTendencia = {
        Docencia1: "",
        Docencia2: "",
        Vinculacion: ""
      };
      //console.log("VACIOOOOO");
      //console.log(this.tipoTendencia);

      if (this.op == 1) {
        this.informacion = {
          nombre: "Desarrollo tecnológico-digital",
          contexto:
            "El despliegue de la economía digital y del conocimiento no solo implica una demanda creciente de expertos en las áreas de matemáticas y tecnologías, sino también un conjunto de habilidades transversales tales como capacidad de trabajo en equipo y en redes, pensamiento crítico, y capacidad de resolución de problemas en ambientes diversos. El posicionamiento de las instituciones de educación superior en los próximos años dependerá en gran medida de en cuánto logran satisfacer la demanda global de capital humano e investigación y desarrollos tecnológicos requeridos por la economía digital."
        };
        this.nombreTendencia = "desarrolloTecnologico";
        this.nombreTendenciaAlert = "Desarrollo tecnológico-digital";
        if (this.tendencia[this.nombreTendencia] != null) {
          this.tipoTendencia = this.tendencia[this.nombreTendencia];
        }
      }
      if (this.op == 2) {
        this.informacion = {
          nombre: "Aumento del envejecimiento y concentración demográfica",
          contexto:
            "Al año 2030, la población mundial será mayor a la actual, y también se encontrará más envejecida"
        };
        this.nombreTendencia = "demografica";
        this.nombreTendenciaAlert =
          "Aumento del envejecimiento y concentración demográfica";
        //console.log("TIPO: ");
        //console.log(this.tipoTendencia);
        if (this.tendencia[this.nombreTendencia] != null) {
          this.tipoTendencia = this.tendencia[this.nombreTendencia];
        }
      }
      if (this.op == 3) {
        this.informacion = {
          nombre: "Reordenamiento geopolítico",
          contexto:
            "El desarrollo económico en Oriente generaría alianzas entre economías emergentes.  En tales escenarios, la política exterior latinoamericana tendría que potenciar sus relaciones económicas con Asia y países desarrollados tales como EEUU; Canadá, Australia y países miembros de la Unión Europea."
        };
        this.nombreTendencia = "reordenamientoGeo";
        this.nombreTendenciaAlert = "Reordenamiento geopolítico";
        //console.log("TIPO: ");
        //console.log(this.tipoTendencia);
        if (this.tendencia[this.nombreTendencia] != null) {
          this.tipoTendencia = this.tendencia[this.nombreTendencia];
        }
      }
      if (this.op == 4) {
        this.informacion = {
          nombre: "Calentamiento global",
          contexto:
            "En Chile, al igual que para el resto del mundo, las proyecciones realizadas por diversos organismos internacionales plantean altos riesgos sobre todo en materia de infraestructuras. Las potenciales amenazas en estos términos son los cambios en el patrón de precipitaciones e incrementos de éstas, aumento en intensidad en inundaciones fluviales, y en inundaciones costeras por aumento en altura de las olas."
        };
        this.nombreTendencia = "calentamientoGlobal";
        this.nombreTendenciaAlert = "Calentamiento global";
        //console.log("TIPO: ");
        //console.log(this.tipoTendencia);
        if (this.tendencia[this.nombreTendencia] != null) {
          this.tipoTendencia = this.tendencia[this.nombreTendencia];
        }
      }
      if (this.op == 5) {
        this.informacion = {
          nombre: "Mayor demanda energética",
          contexto:
            "Chile aumentará su consumo de energía per cápita en la medida en que continúe su desarrollo económico. Es por ello que la Política Energética de nuestro país, estableció en 2015 algunos objetivos en el mediano plazo: modernización del sector energético; acciones que mejoren la calidad de vida de la ciudadanía en materia de energía, relevando un sello social a la política energética; infraestructura energética que el país requiere para un desarrollo sostenible; cómo aprovechar el potencial renovable y enfrentar el desafío del cambio climático; de los contaminantes locales en el sector energético; transporte eficiente (electromovilidad); y educación y capacitación energética."
        };
        this.nombreTendencia = "demandaEnergetica";
        this.nombreTendenciaAlert = "Mayor demanda energética";
        //console.log("TIPO: ");
        //console.log(this.tipoTendencia);
        if (this.tendencia[this.nombreTendencia] != null) {
          this.tipoTendencia = this.tendencia[this.nombreTendencia];
        }
      }
      if (this.op == 6) {
        this.informacion = {
          nombre: "Continuidad crecimiento económico",
          contexto:
            "La economía seguirá creciendo impulsada por los países en vías de desarrollo y China. Continuará habiendo una reducción de la extrema pobreza y al mismo tiempo un aumento de la población que se considera como parte de la clase media. Sin embargo, de la misma forma continuará la tendencia a la acumulación de la riqueza en el 1% más rico de la población. "
        };
        this.nombreTendencia = "crecimientoEcono";
        this.nombreTendenciaAlert = "Continuidad crecimiento económico";
        //console.log("TIPO: ");
        //console.log(this.tipoTendencia);
        if (this.tendencia[this.nombreTendencia] != null) {
          this.tipoTendencia = this.tendencia[this.nombreTendencia];
        }
      }

      if (this.op == 7) {
        this.informacion = {
          nombre: "Urbanización",
          contexto:
            "En una mirada regional, al año 2030 la población urbana de América Latina (AL) superaría el 90%, lo que la convertiría en la región de mayor concentración urbana del planeta"
        };
        this.nombreTendencia = "urbanizacion";
        this.nombreTendenciaAlert = "Urbanización";
        //console.log("TIPO: ");
        //console.log(this.tipoTendencia);
        if (this.tendencia[this.nombreTendencia] != null) {
          this.tipoTendencia = this.tendencia[this.nombreTendencia];
        }
      }
      if (this.op == 8) {
        this.informacion = {
          nombre: "Conectividad",
          contexto:
            "Consecuencias: Aumento del número de automóviles y barcos, y la consecuente contaminación ambiental (aunque una parte importante serán eléctricos); mayor conectividad generará una mayor pluralidad; sustitución de fuentes laborales especializadas (ej. El número de pilotos de vuelos comerciales se triplicará al 2030); el transporte y la logística de las ciudades mejorará con mayor conectividad; aumento de influencia de internet en las noticias, a través de fake news, lo que generará polarización de las elecciones; la conectividad también puede significar vulnerabilidad: el ciberespacio será uno de los campos de batalla donde los estados y actores no estatales se enfrentan; la mayoría de los sistemas de inteligencia artificial requerirán de acceso a big data"
        };
        this.nombreTendencia = "conectividad";
        this.nombreTendenciaAlert = "Conectividad";
        //console.log("TIPO: ");
        //console.log(this.tipoTendencia);
        if (this.tendencia[this.nombreTendencia] != null) {
          this.tipoTendencia = this.tendencia[this.nombreTendencia];
        }
      }
    },
    showAlert(type, message) {
      this.alertType = type;
      this.alertMessage = message;
      this.alert = true;
    },
    getLineas() {
      axios
        .get(
          process.env.ROOT_API +
            "/investigacionConsolidado/allInvestigacionesFuturosAndTendencia?ccValor=" +
            this.ccValor +
            "&tendencia=" +
            this.op,
          this.auth
        )
        .then(response => {
          this.lineas = response.data;
          //console.log(response.data);
          if (response.data.length != 0) {
            this.empty = false;
          } else {
            this.empty = true;
          }
        })
        .catch(error => {
          console.error(error);
        });
    },

    openEditLineas(linea, index, parteEncuesta) {
      //console.log(parteEncuesta);
      if (parteEncuesta == "edit") {
        this.edit = true;
      }
      if (parteEncuesta == "edit1") {
        this.edit1 = true;
      }
      if (parteEncuesta == "edit2") {
        this.edit2 = true;
      }
      if (parteEncuesta == "edit3") {
        this.edit3 = true;
      }
      this.create = false;

      this.index = index;
      this.linea = linea;
      //console.log(this.linea);
    },

    opencreateFocos() {
      this.create = true;
      this.edit = true;
      this.linea = {};
    },

    editLinea() {
      axios
        .put(
          process.env.ROOT_API +
            "/investigacionConsolidado/updateInvestigacion",
          this.linea,
          this.auth
        )
        .then(response => {
          //console.log(response.data);
          this.showAlert(
            "success",
            "Línea " + this.linea.nombreLinea + " editada"
          );
          this.getLineas();
        })
        .catch(error => {
          console.error(error);
          this.showAlert("error", error);
        });
      this.edit = false;
      this.edit1 = false;
      this.edit2 = false;
      this.edit3 = false;
    },

    createLinea() {
      this.linea.temporalidad = "Futuro";
      this.linea.tendencia = this.op;
      axios
        .post(
          process.env.ROOT_API +
            "/investigacionConsolidado/createInvestigacion?ccValor=" +
            this.ccValor,
          this.linea,
          this.auth
        )
        .then(response => {
          //console.log(response.data);
          this.showAlert("success", "Línea creada");
          this.getLineas();
        })
        .catch(error => {
          console.error(error);
          this.showAlert("error", error);
        });
      this.edit = false;
    },

    openDeleteLineas(linea, index) {
      this.eliminar = true;
      this.index = index;
      this.linea = linea;
    },
    deleteLinea(item) {
      axios
        .delete(
          process.env.ROOT_API +
            "/investigacionConsolidado/delete?idLinea=" +
            item.id,
          this.auth
        )
        .then(response => {
          //console.log(response.data);
          this.showAlert("success", response.data);
          this.getLineas();
        })
        .catch(error => {
          console.error(error);
          this.showAlert("error", error);
        });
      this.eliminar = false;
    }
  }
};
</script>


<style scoped>
.new-alert {
  z-index: 9000;
  width: auto;
  margin-top: 5px;
  margin-left: auto;
  margin-right: auto;
}

.new-alert .theme--light.v-icon {
  color: #ffffff !important;
}

p.titulo-pregunta {
  margin: 0;
  font-weight: bold;
  text-decoration: underline;
  font-size: 15px;
  color: #ec6a12;
}
.image {
  cursor: pointer;
}
.text-mision {
  color: rgb(0, 0, 0);
  font-size: 11px;
}

.titlep {
  color: #ec6a12;
  font-size: 18px;
}

.table2 {
  height: 100px !important;
}

.v-card-new {
  margin-top: 50px;
  margin-bottom: 3%;
  margin-left: 3%;
  padding-right: 15px;
  padding-left: 15px;
  padding-top: 0.5%;
  background: #394049 !important;
  height: auto !important;
  overflow-y: auto;
}

.v-card {
  height: auto;
  overflow-y: auto;
}

.td-color {
  background: #394049;
  height: 100%;
}

.containerBanner {
  width: 100%;
  margin-top: 50px !important;
}

.font {
  color: white !important;
}

.containerStyle2 {
  width: 100% !important;
  margin-top: 10px !important;
}
.video {
  width: 100% !important;
  margin-top: 10px !important;
  height: 400px;
}

.containerStyle1 {
  width: 100%;
  margin-top: 25%;
  margin-bottom: 50px;
}

.pull {
  text-align: justify;
}

.v-list-new {
  height: 100% !important;
}

.v-btn__content {
  font-size: 10px !important;
}

.theme--light.v-btn {
  color: white;
}

.v-btn {
  font-size: 10px;
  border-radius: 50px;
}

/* width */
::-webkit-scrollbar {
  width: 3px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.bottom {
  margin-bottom: 50px !important;
}

.header-fixed {
  width: 100%;
  overflow-y: auto;
  height: 200px !important;
}
.header-fixed > thead,
.header-fixed > thead > tr,
.header-fixed > thead > tr > th {
  display: block;
  text-align: left;
  background: #e47215;
  color: #fff;
}

.header-fixed > thead > tr:after {
  content: " ";
  display: block;
  visibility: hidden;
  clear: both;
}
.header-fixed > tbody {
  overflow-y: auto;
  height: 200px;
  width: 100%;
  background: #394049;
}

.header-fixed > thead > tr > th {
  float: left;
  font-size: 13px;
}

.header-fixed > tbody > tr > td {
  float: left;
  font-size: 18px;
  background: #394049;
}

.td-class {
  vertical-align: middle;
  font-size: 12px;
  background: #394049;
}

.test {
  height: 200px !important;
  overflow-y: auto;
}

.header {
  background: #e47215;
  color: #ffffff;
}
table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
}

.tbl-content {
  height: 320px;
  overflow-y: auto;
  margin-top: 0px;
  background: #f1f1f1;
}
th {
  padding: 20px 15px;
  text-align: left;
  font-weight: 500;
  font-size: 13px;
}
td {
  padding: 15px;
  text-align: left;
  vertical-align: middle;
  font-weight: 300;
  font-size: 12px;
  height: 104px;
  border-bottom: solid 1px rgba(0, 0, 0, 0);
  color: #000000;
}

.text-actividad {
  color: rgb(0, 0, 0);
  text-align: justify;
}
</style>


// WEBPACK FOOTER //
// src/components/definicionEstrategica/Tendencias.vue